/**
 * PesticidesAdminPage — системная админка справочника СЗР (AK-385).
 *
 * platform_admin · /platform-admin/reference/pesticides · управление глобальным
 * каталогом (не тенант). Три вкладки:
 *   A. Импорт редакции госкаталога (заглушка под ETL).
 *   B. Очередь разбора маппинга (привязка raw_text → каталог).
 *   C. Подсправочники (CRUD pesticide-specific + ссылка на ед.изм.).
 *
 * Внутри PlatformAdminLayout (единый shell platform-admin). Wireframe:
 * docs/superpowers/prototypes/ak-pesticides/admin.html.
 */
import { useState } from 'react';
import { PlatformAdminLayout } from '@/layouts/PlatformAdminLayout';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ImportPanel } from './ImportPanel';
import { MappingQueuePanel } from './MappingQueuePanel';
import { SubCatalogsPanel } from './SubCatalogsPanel';

type AdminTab = 'import' | 'queue' | 'sub';

export function PlatformAdminPesticidesPage() {
  const [tab, setTab] = useState<AdminTab>('import');

  return (
    <PlatformAdminLayout>
      <div>
        <h1 className="text-2xl font-semibold text-foreground">
          Пестициды (СЗР)
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Глобальный каталог зарегистрированных СЗР · импорт, разбор маппинга,
          подсправочники. Источник: Госкаталог Минсельхоза РФ.
        </p>
      </div>

      <Tabs value={tab} onValueChange={(v) => setTab(v as AdminTab)} className="mt-5">
        <TabsList>
          <TabsTrigger value="import">Импорт</TabsTrigger>
          <TabsTrigger value="queue">Очередь маппинга</TabsTrigger>
          <TabsTrigger value="sub">Подсправочники</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="mt-4">
        {tab === 'import' && <ImportPanel />}
        {tab === 'queue' && <MappingQueuePanel />}
        {tab === 'sub' && <SubCatalogsPanel />}
      </div>
    </PlatformAdminLayout>
  );
}

export default PlatformAdminPesticidesPage;
